import { FC, useState } from "react";
import { Navigate, useLocation } from "react-router-dom";

import useAuth from "@hooks/useAuth";
import usePermissions from "@hooks/usePermissions";

import { IdleContextProvider } from "@contexts/Idle";

import { PageLayout } from "@components/PageLayout";
import { JivoChat } from "@components/JivoChat";
import { AcceptTermosModal } from "@components/AcceptTermsModal";
import { featureFlags } from "@settings";
import { PRODUCT_TYPE } from "@utils/enums";
import { AlertModal } from "@components/AlertModal";

const {
  enableAcceptTermsCef,
  enableBatchTypingMarginIncrease,
  enableModalUnavailabilityCef,
} = featureFlags;

export const PageLayoutProtected: FC = () => {
  const { user, hasProduct } = useAuth();
  const { allowedRoutes, loading, acceptedTerms } = usePermissions();

  const [modalTermsOpen, setModalTermsOpen] = useState<boolean>(
    () => !acceptedTerms,
  );

  const hasMarginIncrease = hasProduct(PRODUCT_TYPE.MARGEM_LIVRE_AUMENTO);

  const location = useLocation();

  if (!user) {
    return <Navigate to="/" replace />;
  } else if (loading) {
    return null;
  } else if (user.enableFaceMatch && !user.isChecked) {
    return <Navigate to="/validacao" replace />;
  } else {
    const matchingRoute = allowedRoutes.find((key) =>
      location.pathname.startsWith(key),
    );

    if (!matchingRoute) {
      return <Navigate to="/sem-acesso" replace />;
    }
  }

  return (
    <>
      <IdleContextProvider>
        <PageLayout showSider showHeader />
        {user.supportChat && <JivoChat />}
        {!acceptedTerms && enableAcceptTermsCef && (
          <AcceptTermosModal
            open={modalTermsOpen}
            onClose={() => setModalTermsOpen(false)}
          />
        )}
      </IdleContextProvider>

      {hasMarginIncrease && enableBatchTypingMarginIncrease && (
        <AlertModal
          storageKey="modalBatchOpened"
          message={
            <>
              Identificamos que você pode ter CPF’s aptos para{" "}
              <strong>Aumento Salarial</strong>. Acesse o produto{" "}
              <strong>Digitação em Lote</strong> para conferir e dar
              continuidade ao processo.
            </>
          }
        />
      )}

      {enableModalUnavailabilityCef && (
        <AlertModal
          storageKey="unavailabilityModalOpened"
          showDivider
          message={
            <>
              A simulação e a digitação de novas propostas estão{" "}
              <strong>temporariamente pausadas</strong> para ajustes
              operacionais. Avisaremos assim que a operação for retomada.
            </>
          }
        />
      )}
    </>
  );
};
